import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function Reports() {

  const [activeTab, setActiveTab] = useState("CEO daily");

  const reportHistory = [
    { date: "02 Jun 2025", cleanedS: 18, cleanedU: 14, yield: 14, due: 11 },
    { date: "01 Jun 2025", cleanedS: 21, cleanedU: 17, yield: 18, due: 9 },
    { date: "31 May 2025", cleanedS: 19, cleanedU: 16, yield: 12, due: 7 }
  ];

  return (
    <>
    
  <Navbar />

  <Sidebar />

  <div className="admin-content">

      <div className="reports-page">

        {/* HEADER */}
        <div className="reports-header">

          <div>
            <h2 style={{ margin: 0 }}>Reports</h2>
          </div>

          <button className="trigger-btn">
            ✈ Trigger CEO report now
          </button>

        </div>

        {/* TABS */}
        <div className="report-tabs">

          {["CEO daily", "Horticulture", "Office", "Bore operations"].map((tab) => (
            <button
              key={tab}
              className={`tab-btn ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}

        </div>

        {/* SUMMARY CARDS */}
        <div className="summary-grid">

          <div className="summary-card">
            <p>Plots cleaned today</p>
            <h1>32</h1>

            <div className="progress-row">
              <div className="progress-bar">
                <div className="progress-fill"></div>
              </div>

              <span>18 ▲ Ulaganathan 14</span>
            </div>
          </div>

          <div className="summary-card">
            <p>Yield reported</p>
            <h1>14</h1>
          </div>

          <div className="summary-card">
            <p>Maintenance due plots</p>
            <h1 className="danger-text">11</h1>
          </div>

        </div>

        {/* REPORT HISTORY */}
        <div className="history-section">

          <h4>DAILY REPORT HISTORY</h4>

          <table className="reports-table">

            <thead>
              <tr>
                <th>Date</th>
                <th>Plots cleaned (S)</th>
                <th>Plots cleaned (U)</th>
                <th>Yield reported</th>
                <th>Due plots</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {reportHistory.map((item, index) => (
                <tr key={index}>
                  <td>{item.date}</td>
                  <td>{item.cleanedS}</td>
                  <td>{item.cleanedU}</td>
                  <td>{item.yield}</td>
                  <td className="danger-text">{item.due}</td>
                  <td>
                    <button className="view-btn">
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>

        </div>

      </div>

    </div>

    </>
  );
}

export default Reports;